import {
    Alert,
    Button,
    Col,
    FloatingLabel,
    Form,
    InputGroup,
    Modal,
    ProgressBar,
    Row,
    Table
} from "react-bootstrap";
import React, {useEffect, useState} from "react";
import {useAuth} from "../../providers/authprovider";
import {getExpirationBgColor} from "./Workers";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faFilePdf, faTrash} from "@fortawesome/free-solid-svg-icons";
import useAlert from "../../components/CustomAlert";

export default function EditUserTrainingsModal(props){

    const {privilege} = props;
    const {users, viewFile} = useAuth();
    const worker = props.worker;
    const [trainings, setTrainings] = useState(props.worker.trainings);
    const [editTraining, setEditTraining] = useState(undefined);
    const {showAlert, hideAlert, alert} = useAlert()
    const handleSave = (training)=>{
        setEditTraining(undefined)
        const existingIndex = trainings.findIndex(c=>c.id === training.id)
        if(existingIndex > -1)
            trainings.splice(existingIndex, 1, training)
        else
            trainings.push(training)

        setTrainings([...trainings]);
    }
    const edit = (training)=>{
        setEditTraining(training)
    }

    const handleHide = ()=>{
        props.onHide({
            user_id:worker.id,
            trainings:trainings
        })
    }

    const getPdfIco = (training)=>{
        if(training.files === 0)
            return null;

        return <Button variant={"outline-info"} size={"sm"} onClick={(e)=>handleShowPdf(e, training)} ><FontAwesomeIcon icon={faFilePdf} className={"cursor-pointer"}  /></Button>
    }

    const handleShowPdf = (e, training)=>{
        e.stopPropagation()
       users.downloadTraining(training.id, ({success, error, content})=>{

           console.log(content)

            if(success)
                viewFile(content.file, content.type)
        });
    }

    const handleDeleteTraining = (e, training)=>{
        e.stopPropagation()

        hideAlert()

        users.deleteTraining(training.id, ({success, error, content})=>{

            if(!success)
                return showAlert(error)

            setTrainings(prev=>{
                return prev.filter(oldTraining => oldTraining.id !== training.id);
            })

        })
    }



    return (
        <Modal
            show={true}
            onHide={handleHide}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
                    <Modal.Header closeButton>
                        <Modal.Title id="contained-modal-title-vcenter">
                            Lista szkoleń - {worker.name}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {alert()}
                        <Table>
                            <thead>
                                <tr>
                                    <th>Data</th>
                                    <th>Nazwa</th>
                                    <th>Opis</th>
                                    <th>Plik</th>
                                    <th>Usuń</th>
                                </tr>
                            </thead>
                            <tbody>
                            {
                                trainings?.map(training=>
                                    <tr key={training.id} className={"cursor-pointer"} onClick={()=>{edit(training)}}>
                                        <td><span className={`${getExpirationBgColor(training)} p-1 border-1 `}>{new Date(training.expiration_date).toLocaleDateString()}</span></td>
                                        <td>{training.name}</td>
                                        <td>{training.description}</td>
                                        <td>{getPdfIco(training)}</td>
                                        <td><Button variant={"outline-dark"} onClick={(event)=>{handleDeleteTraining(event,training)}}><FontAwesomeIcon icon={faTrash} /></Button> </td>
                                    </tr>
                                )
                            }
                            </tbody>
                        </Table>
                        {
                            privilege.edit && <TrainingForm worker_id={worker.id} training={editTraining} onsave={handleSave} />
                        }

                    </Modal.Body>
        </Modal>
    )
}

function TrainingForm(props){
    const EMPTY_TRAINING = {name:"", description:"", expiration_date:""}
    const {users} = useAuth();
    const [validated, setValidated] = useState(false);
    const [alert, setAlert] = useState({
        show:false,
        content:"",
    })
    const hideAlert = ()=>{
        setAlert({
            show:false,
            content:"",
        })
    }
    const [uploading, setUploading] = useState([false, 0])
    const handleChange = (event)=>{
        setTrainingData({...trainingData, [event.target.name]:event.target.value});
    }
    const handleSubmit = (event)=>{
        const form = event.target;

        event.preventDefault();
        event.stopPropagation();

        if (form.checkValidity() === true) {

            const formData = new FormData();

            formData.append('userId', props.worker_id);

            Object.keys(trainingData).forEach(key=>{
                formData.append(key, trainingData[key])
            })

            if(form.file.files.length > 0){
                formData.append('file', form.file.files[0]);
            }
            setUploading([true, 0]);

            users.addTraining(formData, uploadProgressHandler, ({success, error, content})=>{
                setUploading([false, 0])

                if(success){

                    setTrainingData(EMPTY_TRAINING)
                    form.reset();
                    setValidated(false);
                    props.onsave(content)
                } else {
                    setAlert({show:true, content:error});
                }
            })

        }

        setValidated(true);
    }

    const uploadProgressHandler = (event)=>{
        let percent = 0;
        let position = event.loaded || event.position;
        let total = event.total;
        if (event.lengthComputable) {
            percent = Math.ceil(position / total * 100);
        }

        setUploading([true, percent]);
    }

    const [trainingData, setTrainingData] = useState(EMPTY_TRAINING);

    useEffect(()=>{
        if(props.training === undefined)
            setTrainingData(EMPTY_TRAINING)
        else{
            props.training.expiration_date = props.training.expiration_date.split("T")[0]
            setTrainingData(props.training)
        }

    }, [props.training])

    return (
        <>
            <Alert show={alert.show} variant={"danger"} onClose={hideAlert} dismissible>
                <p>
                    {alert.content}
                </p>
            </Alert>
            <Form noValidate validated={validated} onSubmit={handleSubmit} className={"p-2 border border-1"}>
                    <h4>Szkolenie</h4>
                    <Row className={"mb-2"}>
                        <Col>
                            <FloatingLabel
                                controlId="floatingNames"
                                label="Nazwa szkolenia"
                                className="mb-3"
                            >
                                <Form.Control
                                    type="text"
                                    placeholder={"nazwa szkolenia"}
                                    name={"name"}
                                    onChange={handleChange}
                                    value={trainingData.name}
                                    required={true}
                                />
                                <Form.Control.Feedback type="invalid">
                                    Prosze podać nazwę szkolenia
                                </Form.Control.Feedback>
                            </FloatingLabel>
                        </Col>
                        <Col>
                            <FloatingLabel
                                controlId="description"
                                label="Opis"
                                className="mb-3"
                            >
                                <Form.Control
                                    as={"textarea"}
                                    name={"description"}
                                    value={trainingData.description}
                                    placeholder={"Opis"}
                                    onChange={handleChange}
                                />
                            </FloatingLabel>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <InputGroup className="mb-3">
                                <InputGroup.Text id="expiration_date">Data wygaśnięcia</InputGroup.Text>
                                <Form.Control
                                    value={trainingData.expiration_date}
                                    type="date" name={"expiration_date"}
                                    placeholder=""
                                    required={true}
                                    onChange={handleChange}
                                />
                                <Form.Control.Feedback type="invalid">
                                    Podaj termin ważności szkolenia
                                </Form.Control.Feedback>
                            </InputGroup>
                        </Col>
                        <Col>
                            <Form.Group controlId="formFile" className="mb-3">
                                <Form.Control type="file" accept={"application/pdf, image/*"} name="file" placeholder={"wybierz plik"} />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Button className={"w-100 mb-2"} type={"submit"}>Zapisz</Button>
                            {
                                uploading[0] &&
                                <ProgressBar now={uploading[1]} label={`${uploading[1]}%`} />
                            }
                        </Col>
                    </Row>
                </Form>

        </>
    )
}

